jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   // $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   // });
document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
  ele.addEventListener("input", function () {
    if (this.value < 0) {
        this.value = 0;
    }
  });
});
  $(document).on("variant:changed", function (evt) {
    // console.log(evt.currentVariant.title);
    document.querySelector(`.cartFusion_fbt_item select option[value="${evt.currentVariant.id}"]`).selected = true;
    // document.querySelector(`.sr4-shoppay-custom-btn option[value="${evt.currentVariant.id}"]`).selected = true;
    if (evt.currentVariant.title.includes('Custom')) {
        document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
            ele.removeAttribute("disabled");
        });
    } else {
        document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
            ele.setAttribute("disabled", "disabled");
        });
    };
  });

  document.querySelectorAll('#CustomSizeTab input').forEach((inp)=>{
    inp.addEventListener('input',()=>{
        document.querySelector(`.cartFusion_fbt_wrapper input[id="${inp.id}"]`).value = inp.value;
    })
})

});
document.addEventListener('DOMContentLoaded', function() {
  const priceElements = document.querySelectorAll('.cartFusion_fbt_wrapper .pitemprice');
  priceElements.forEach(function(item) {
    const moneySpan = item.querySelector('.money');
    if (moneySpan) {
      const text = moneySpan.textContent.trim();
      if (text === 'PKR 0' || text === '0') {
        item.style.display = 'none';
      }
    }
  });
});